import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { AnonymousAuthenticationPreloaderBlockConfig } from '@front-platform/content-builder';
import { anonymousAuthenticationPreloaderBlockResolveConfig } from '@front-platform/content-builder';
import { Component, inject, input } from '@angular/core';
import { AnonymousAuthenticationService } from '@core/services/auth/anonymous-authentification.service';
export interface AnonymousAuthenticationPreloaderBlockRuntimeConfig {}

export type AnonymousAuthenticationPreloaderBlockConfigInput = Partial<
  Omit<
    AnonymousAuthenticationPreloaderBlockConfig,
    keyof AnonymousAuthenticationPreloaderBlockRuntimeConfig
  > &
    AnonymousAuthenticationPreloaderBlockRuntimeConfig
>;
export type AnonymousAuthenticationPreloaderBlockResolvedConfig = Omit<
  AnonymousAuthenticationPreloaderBlockConfig,
  keyof AnonymousAuthenticationPreloaderBlockRuntimeConfig
> &
  Partial<AnonymousAuthenticationPreloaderBlockRuntimeConfig>;
export interface AnonymousAuthenticationPreloaderBlockContract extends ConfigComponentContract<
  AnonymousAuthenticationPreloaderBlockConfigInput,
  AnonymousAuthenticationPreloaderBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-anonymous-authentication-preloader-block',
  standalone: false,
})
export class AnonymousAuthenticationPreloaderBlockComponent implements AnonymousAuthenticationPreloaderBlockContract {
  readonly config = input<AnonymousAuthenticationPreloaderBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    AnonymousAuthenticationPreloaderBlockConfig,
    AnonymousAuthenticationPreloaderBlockRuntimeConfig
  >(anonymousAuthenticationPreloaderBlockResolveConfig, () => ({ config: this.config() }));
  private readonly anonymousAuthenticationService = inject(AnonymousAuthenticationService);

  constructor() {
    this.anonymousAuthenticationService.ensureAnonymousSession$().subscribe();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(AnonymousAuthenticationPreloaderBlockComponent, {
  'keyAliases': {},
});
